export default __webpack_public_path__ + "static/media/stripe-badge.c4f72bcf.svg";